class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.menuPrimaryItems = document.querySelectorAll('.menu-primary-item');
    this.mask = document.querySelector('.header-mask');
    this.form = this.querySelector('form');
    this.localizationForm = document.querySelector('localization-form');
    
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Catch enter key
    this.input.addEventListener("keypress", this.debounce((event) => {
      console.log('keypress');
      if (event.which === 13 || event.keyCode === 13) {
        if ( this.input.value.trim().length ) {
          this.submit();
        }
      }
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[limit]=6&resources[limit_scope]=each`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const markup = new DOMParser().parseFromString(text, 'text/html');

        if ( markup.querySelector('.layout-predictive-search-results').dataset.noResults == 'true' ) {
          // No results, load search page
          console.log('no results');
          this.submit();
        } else {
          // Show instant results
          this.predictiveSearchResults.innerHTML =  markup.querySelector('#shopify-section-predictive-search').innerHTML;
          this.open();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    // Close menu if open
    this.menuPrimaryItems.forEach((item, i) => {
      item.classList.remove('is-active');
    });

    // Close the localisation form
    if (this.localizationForm) {
      this.localizationForm.hidePanel();
    }

    this.predictiveSearchResults.style.display = 'block';
    this.mask.classList.add('is-active');
    lazyLoadInstance.update();
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.mask.classList.remove('is-active');
  }

  submit() {
    this.form.submit();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);